// ADDED: V2 Table showing summarized criteria count
import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';

const MaintenanceSalaryCombinationV2Table = ({
  data,
  onEdit,
  loading,
  currentPage,
  setCurrentPage
}) => {
  const headers = ["Category", "Salary", "Actions"];
  const accessors = ["category", "salary", "actions"];

  const actions = [
    {
      name: "Edit Rule",
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: onEdit,
      visible: true,
    }
  ];

  return (
    <CreateTable
      tableName={"Salary Rule List"}
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      isLoading={loading}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length}
    />
  );
};

export default MaintenanceSalaryCombinationV2Table;